<template>
  <button :aria-label="iconAlt" class="misc" @click.stop.prevent="$emit('callback')">
    <img :src="icon" :alt="iconAlt">
  </button>
</template>

<script>
export default {
  name: 'misc-button',
  props: {
    icon: {
      type: String,
      required: true,
    },
    iconAlt: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.misc {
  @include misc-button;
}
</style>

